import {
  BarGraph,
  CalendarIcon,
  ChatIcon,
  DashboardIcon,
  MapIcon,
  ReportsIcon,
  ESMIcon,
  QualityIcon,
  ProjectIcon,
  JourneyIcon,
  RegisterContentIcon,
  AssistanceIcon,
  FormIcon,
  FarmerIcon,
  TermsIcon,
} from "../components/ImageComponents"
import { RxExternalLink } from "react-icons/rx";
import { GoChecklist } from "react-icons/go";
import Send from "../core/communication"
import containers from "./containerRoutes"
import { store } from "../core/redux/index"
import { VALE_USERS_EMAIL } from "../core/vale/users"
import { ProjectContainer } from "../container/ProjectContainer";
import NewChatContainer from "../container/NewChatContainer";
import { getPlatform } from "../core/utils/platform";
import { ChatProvider } from "../core/context/chatContext";
import PreFormOfflineScreen from "../screen/PreScreenFormOffline";
import { isMobile } from "react-device-detect";
import WhatsAppGate from "../components/WhatsAppGate";

const {
  FarmerContainer,
  DashboardContainer,
  CalendarContainer,
  ReportsContainer,
  AssistanceDetailsContainer,
  BarometroDetailsContainer,
  AssistanceContainer,
  ProviderJourneyContainer,
  ProjectAnalysisContainer,
  AssistanceListContainer,
  ContentDetailsContainer,
  ChatContainer,
  CompleteESMContainer,
  ContentListContainer,
  ContentPageContainer,
  QualityContainer,
  ESMCommunityPlanContainer,
  ESMContainer,
  ESMDetailsContainer,
  AssistanceToResolveContainer,
  ScaleIndicatorListContainer,
  IndicatorDetailsContainer,
  EmbrapaDetailsSuinosContainer,
  EmbrapaSuinosContainer,
  EvidencesDetailsContainer,
  DashboardDetailsContainer,
  DashboardListContainer,
  ReportsContainerPlatformOne,
  BurnedContainer,
  DynamicDashContainer,
  TermsOfUseListContainer,
  LatestAppointmentsContainer,
  AssistanceGenerateLinkContainer,
  PlanningContainer,
  AssistanceLinkFormStepsContainer,
  DataSheetGrid,
  FarmerProfileContainer,
  NewAssistanceContainer,
  SchedulePlanContainer,
  ActivityHistoryContainer,
  ProjectSummarycontainer,
  FarmerImportContainer
} = containers

export const isDashboard =
getPlatform() === "1" || getPlatform() === "2"

export const isChatPlatform = getPlatform() === "3";

export const isChatOnlyPlatform = getPlatform() === "4";

const dashboardRoutes = [
  {
    path: "/",
    name: "Dashboards",
    component: () => <DashboardListContainer />,
    icon: <DashboardIcon />,
  },
  {
    path: "/projects/summary",
    name: "Resumo de Projetos",
    component: ProjectSummarycontainer,
    icon: <DashboardIcon/>,
    // hidden: true,
    // hiddenHeader: true,
    isRole: ["USER_ADMIN", "USER_MANAGER"],
  },
  // {
  //   path: "/projects",
  //   name: "Projetos",
  //   component: () => <ProjectContainer />,
  //   icon: <DashboardIcon />,
  // },
  {
    path: "/reports-download",
    name: "Relatórios",
    hidden: true,
    component: ReportsContainer,
    icon: <FormIcon/>,
    isRole: ["USER_ADMIN", "USER_MANAGER"],
  },
  {
    path: "/calendar",
    name: "Calendário",
    hidden: true,
    component: CalendarContainer,
    icon: <CalendarIcon/>,
  },
  {
    path: "/dashboard/:id",
    name: "Detalhes",
    component: () => <DashboardDetailsContainer />,
    icon: <DashboardIcon />,
    hidden: true,
  },
  {
    path: "/dashboard/dynamic/:id",
    name: "Detalhes",
    component: (props) => <DynamicDashContainer {...props} />,
    icon: <DashboardIcon />,
    hidden: true,
  },
  {
    path: "/reports",
    name: "Arquivos",
    component: ReportsContainerPlatformOne,
    hidden: true,
    icon: <ReportsIcon/>,
  },
  {
    path: "/geo",
    name: "Geolocalização",
    component: BurnedContainer,
    icon: <MapIcon />,
  },
  {
    path: "/esm/:esmId",
    name: "Escala de Sustentabilidade ManejeBem",
    hidden: true,
    component: ESMContainer,
    icon: <ESMIcon />,
  },
  {
    path: "/journey",
    name: "Jornada",
    hidden: true,
    hiddenHeader: true,
    component: ProviderJourneyContainer,
    icon: <JourneyIcon/>,
  },
  {
    path: "/assistance/all",
    icon: <AssistanceIcon/>,
    name: "Atendimentos",
    hidden: true,
    hiddenHeader: true,
    component: AssistanceContainer,
  },
  {
    path: "/assistance/list",
    name: "Lista de Atendimentos",
    component: AssistanceListContainer,
    icon: "",
    hidden: true,
  },
  {
    path: "/details/content",
    name: "Lista de Conteúdos",
    component: ContentListContainer,
    icon: "",
    hidden: true,
  },
  ,
  {
    path: "/details/content/:userId/:muralId",
    name: "Detalhes do conteúdo",
    component: ContentDetailsContainer,
    icon: "",
    hidden: true,
  },
  {
    path: "/assistance/:id/details",
    name: "Detalhes do Atendimento",
    component: AssistanceDetailsContainer,
    icon: "",
    hidden: true,
  },
  {
    path: "/analise/projetos",
    name: "Projetos",
    hidden: true,
    hiddenHeader: true,
    component: ProjectAnalysisContainer,
    icon: <ProjectIcon />,
  },
  {
    path: "/evidences/details",
    name: "Evidencias",
    component: EvidencesDetailsContainer,
    icon: <BarGraph />,
    isRole: ["USER_ADMIN"],
    hidden: true,
  },
  {
    path: "/esm/producer/plan/community",
    name: "Plano de Desenvolvimento da Comunidade",
    hidden: true,
    component: ESMCommunityPlanContainer,
    icon: <DashboardIcon />,
  },
  {
    path: "/esm/:esmId/producer/:userId",
    name: "ESM Produtores",
    component: ESMDetailsContainer,
    icon: <DashboardIcon />,
    isRole: ["USER_ADMIN"],
    hidden: true,
  },
  {
    path: "/esm/:id/community",
    component: ESMDetailsContainer,
    icon: <DashboardIcon />,
    isRole: ["USER_ADMIN"],
    hidden: true,
    hiddenHeader: true
  },
]

const platformRoutes = [
  {
    path: "/",
    name: "Início",
    component: NewAssistanceContainer,
    icon: <DashboardIcon/>,
    hiddenHeader: true
  },
  {
    path: "/projects/summary",
    name: "Resumo de Projetos",
    component: ProjectSummarycontainer,
    icon: <DashboardIcon/>,
    hiddenHeader: true
  },
  {
    path: "/users",
    name: "Beneficiários",
    component: FarmerContainer,
    hiddenHeader: true,
    icon: <FarmerIcon/>,
  },
  {
    path: "/farmer/import",
    name: "Adicionar/Importar Beneficiários",
    component: FarmerImportContainer,
    icon: <FarmerIcon/>,
    hiddenHeader: true,
    hidden: true
  },
  {
    path: "/chat",
    name: "Chat",
    component: (props) => (
      <ChatProvider>
        <WhatsAppGate>
          <NewChatContainer {...props}/>
        </WhatsAppGate>
      </ChatProvider>
    ),
    icon: <ChatIcon />,
    hiddenHeader: true,
  },
  {
    path: "/farmer/profile/:userId",
    name: "Perfil de Produtores",
    component: FarmerProfileContainer,
    icon: <FarmerIcon/>,
    hiddenHeader: true,
    hidden: true
  },
  {
    path: "/planning",
    name: "Planejamento",
    component: () => <PlanningContainer />,
    icon: <GoChecklist />,
    isRole: ["USER_ADMIN"],
    restricted: ['produtordeconteudos@manejebem.com', 'tec02ma@manejebem.com', 'comunicação@manejebem.com', 'tec_goias2@manejebem.com', 'suportetransformação@manejebem.com']
  },
  {
    path: "/assistance/resolve",
    name: "Atendimentos Pendentes",
    component: AssistanceToResolveContainer,
    hidden: true,
    icon: <AssistanceIcon/>,
  },
  {
    path: "/appointments",
    name: "Últimos Atendimentos",
    component: LatestAppointmentsContainer,
    isRole: ["USER_ADMIN"],
    icon: <AssistanceIcon/>,
  },
  // {
  //   path: "/send-forms",
  //   name: "Envio de Formulário",
  //   component: AssistanceGenerateLinkContainer,
  //   icon: <RxExternalLink />
  // },
  // {
  //   path: "/terms",
  //   name: "Automação",
  //   component: TermsOfUseListContainer,
  //   icon: <TermsIcon/>,
  // },
  {
    path: "esm/indicator/new/:esmId",
    name: "Novo Indicador",
    component: IndicatorDetailsContainer,
    hidden: true,
    hiddenHeader: true,
    icon: <DashboardIcon />,
  },
  {
    path: "esm/indicator/:esmId/:indicatorId",
    name: "Detalhes do Indicador",
    component: IndicatorDetailsContainer,
    hidden: true,
    hiddenHeader: true,
    icon: <DashboardIcon />,
  },
  {
    path: "/esm/completo",
    name: "Esm",
    hidden: false,
    hiddenHeader: true,
    component: CompleteESMContainer,
    isRole: ["USER_ADMIN"],
    icon: <ESMIcon />,
  },
  {
    path: "/esm/indicators/:esmId",
    name: "Indicadores ESM",
    hidden: true,
    hiddenHeader: true,
    component: ScaleIndicatorListContainer,
    icon: <DashboardIcon />,
  },
  // {
  //   path: "/qualidade",
  //   name: "Qualidade",
  //   component: QualityContainer,
  //   icon: <QualityIcon />,
  // },
  // {
  //   path: "/esm/completo",
  //   name: "Esm Completo",
  //   hidden: true,
  //   component: CompleteESMContainer,
  //   icon: <DashboardIcon />,
  // },
  // {
  //   path: "/barometro",
  //   name: "Barômetro",
  //   // hidden: true,
  //   component: BarometroContainer,
  //   icon: <DashboardIcon />,
  // },
  // {
  //   path: "/assistance/analysis",
  //   name: "Análise de Atendimento",
  //   component: AssistanceAnalysisContainer,
  //   icon: <DashboardIcon />,
  // },
  // {
  //   path: "/assistance/analysis/reports/:id",
  //   name: "Análise de Atendimento Detalhes",
  //   component: AssistanceAnalysisReportsContainer,
  //   icon: <DashboardIcon />,
  //   hidden: true
  // },
  // {
  //   path: "/assistance/analysis/reports/clustered/:id",
  //   name: "clustered ",
  //   component: ClusteredPathTopicsContainer,
  //   icon: <DashboardIcon />,
  //   hidden: true
  // },
  {
    path: "/barometro/detalhes",
    name: "Barômetro",
    component: BarometroDetailsContainer,
    icon: <DashboardIcon />,
    hidden: true,
  },

  // {
  //   path: "/admin/dasboard",
  //   name: "Dashboard",
  //   component: ProjectDashContainer,
  //   icon: <DashboardIcon />,
  // },
  // {
  //   path: "/historic",
  //   name: "Histórico",
  //   component: HistoricContainer,
  //   icon: <HistoryIcon />,
  // },
  {
    path: "/calendar",
    name: "Calendário",
    component: CalendarContainer,
    icon: <CalendarIcon/>,
    isRole: ["USER_ADMIN"],
  },
  // {
  //   path: "/reports",
  //   name: "Relatórios",
  //   component: ReportsContainer,
  //   icon: <FormIcon/>,
  //   isRole: ["USER_ADMIN", "USER_MANAGER"],
  // },
  // {
  //   path: "/contents",
  //   name: "Registro de Conteúdos",
  //   component: ContentPageContainer,
  //   icon: <RegisterContentIcon/>,
  // },
  // {
  //   path: "/journey",
  //   name: "Jornada",
  //   component: ProviderJourneyContainer,
  //   icon: <JourneyIcon/>,
  // },
  {
    path: "/datasheet",
    name: "Tabela de Respostas",
    component: () => <DataSheetGrid />,
    isRole: ["USER_ADMIN"],
    icon: <DashboardIcon />,
  },
  {
    path: "/analysis",
    name: "Análise",
    component: DashboardContainer,
    icon: <BarGraph />
  },
  {
    path: "/activity/history/farmer/:userId",
    name: "Histórico de Atividades",
    component: ActivityHistoryContainer,
    icon: <DashboardIcon/>,
    hiddenHeader: true,
    hidden: true
  },
  // {
  //   path: "/engagement",
  //   name: "Engajamento",
  //   component: EngagementContainer,
  //   icon: <BarGraph />,
  //   isRole: ["USER_ADMIN", "USER_MANAGER"],
  // },
  // {
  //   path: "/geo",
  //   name: "Geolocalização",
  //   component: MapsContainer,
  //   icon: <MapIcon />
  // },
  // {
  //   path: "/geo",
  //   name: "Geolocalização",
  //   component: BurnedContainer,
  //   icon: <MapIcon />,
  // },
  /* {
    //   path: "/ods-select",
    //   name: "ODS Config.",
    //   component: ODSSelectContainer,
    //   icon: <BarGraph />,
    //   isRole: ["USER_ADMIN"]
  } */
  /* {
    path: "/ods",
    name: "ODS.",
    component: ODSDashboardContainer,
    icon: <BarGraph />,
    isRole: ["USER_ADMIN"],
  }, */
  // {
  //   path: "/companies",
  //   name: "Empresas Cadastradas",
  //   component: BuildingFeature,
  //   icon: <RiDashboard2Fill />,
  // },
  // {
  //   path: "/indicators",
  //   name: "Indicadores",
  //   component: BuildingFeature,
  //   icon: <RiBarChartFill />,
  // },
  // {
  //   path: "/questions",
  //   name: "Banco de Questões",
  //   component: BuildingFeature,
  //   icon: <RiQuestionFill />,
  // },

  // export const indexRoutes = [
  // { path: "/companies/create", name: "Cadastro de Empresas", component: AddCompanyContainer },
  // { path: "/companies/:id", name: "Empresa Cadastrada", component: CompanyHomeContainer },
  // {
  //   path: "/companies/edit/:id",
  //   name: "Editar Informações da Empresa",
  //   component: EditCompanyContainer,
  // },
  // {
  //   path: "/indicators/create",
  //   name: "Cadastro de Indicadores",
  //   component: AddIndicatorsContainer,
  // },
  // {
  //   path: "/indicators/information",
  //   name: "Nome do Indicador",
  //   component: IndicatorsInformationContainer,
  // },
  // {
  //   path: "/projects/edit/company/:companyId",
  //   name: "Editar Projetos",
  //   component: AddEditProjectContainer,
  // },
  // {
  //   path: "/evidence/:userId",
  //   name: "Evidências do usuário",
  //   component: EvidencesContainer,
  // },
]

const chatRoutes = [
  {
    path: "/",
    name: "Produtores",
    component: FarmerContainer,
    icon: <FarmerIcon/>,
  },
  {
    path: "/farmer/profile",
    name: "Perfil de Produtores",
    component: FarmerProfileContainer,
    icon: <FarmerIcon/>,
    hiddenHeader: true,
    hidden: true
  },
  {
    path: "/assistance/resolve",
    name: "Atendimentos Pendentes",
    component: AssistanceToResolveContainer,
    hidden: true,
    icon: <AssistanceIcon/>,
  },
  {
    path: "/chat",
    name: "Chat",
    component: (props) => (
      <WhatsAppGate>
        <NewChatContainer {...props}/>
      </WhatsAppGate>
    ),
    icon: <ChatIcon />,
    hiddenHeader: true
  },
  
]

const chatOnlyRoutes = [
  {
    path: "/",
    name: "Chat",
    component: (props) => (
      <ChatProvider>
        <WhatsAppGate>
          <NewChatContainer {...props}/>
        </WhatsAppGate>
      </ChatProvider>
    ),
    icon: <ChatIcon />,
    hiddenHeader: true,
  }
]

const embrapaRoutes = [
  {
    path: "/",
    name: "Produtores",
    component: EmbrapaSuinosContainer,
    icon: <DashboardIcon />,
  },
  {
    path: "/suinos-details/:id_user",
    name: "Produtores",
    component: EmbrapaDetailsSuinosContainer,
    hidden: true,
    icon: <DashboardIcon />,
  },
  {
    path: "/esm/:esmId",
    name: "Indicadores de sustentabilidade",
    hidden: true,
    component: ESMContainer,
    icon: <DashboardIcon />,
  },
  {
    path: "/esm/producer/plan/community",
    name: "Plano de Desenvolvimento da Comunidade",
    hidden: true,
    component: ESMCommunityPlanContainer,
    icon: <DashboardIcon />,
  },
  {
    path: "/esm/:esmId/producer/:userId",
    name: "Produtores",
    component: ESMDetailsContainer,
    icon: <DashboardIcon />,
    isRole: ["USER_ADMIN"],
    hidden: true,
  },
  {
    path: "/esm/:id/community",
    name: "Comunidade",
    component: ESMDetailsContainer,
    icon: <DashboardIcon />,
    isRole: ["USER_ADMIN"],
    hidden: true,
  },
]

const valeRoutes = [
  {
    path: "/reports",
    name: "Arquivos",
    component: ReportsContainerPlatformOne,
    icon: <ReportsIcon/>,
  },
  {
    path: "/calendar",
    name: "Calendário",
    component: CalendarContainer,
    icon: <CalendarIcon/>,
  },
  {
    path: "/reports-download",
    name: "Relatórios",
    component: ReportsContainer,
    icon: <FormIcon/>,
    isRole: ["USER_ADMIN", "USER_MANAGER"],
  },
  {
    path: "/geo",
    name: "Geolocalização",
    component: BurnedContainer,
    icon: <MapIcon />,
  },
  {
    path: "/esm/:esmId",
    name: "Índice Avançado de Qualidade do Solo",
    hidden: true,
    component: ESMContainer,
    icon: <DashboardIcon />,
  },
  {
    path: "/esm/producer/plan/community",
    name: "Plano de Desenvolvimento da Comunidade",
    hidden: true,
    component: ESMCommunityPlanContainer,
    icon: <DashboardIcon />,
  },
  {
    path: "/esm/:esmId/producer/:userId",
    name: "Produtores",
    component: ESMDetailsContainer,
    icon: <DashboardIcon />,
    isRole: ["USER_ADMIN"],
    hidden: true,
  },
  {
    path: "/esm/:id/community",
    name: "Comunidade",
    component: ESMDetailsContainer,
    icon: <DashboardIcon />,
    isRole: ["USER_ADMIN"],
    hidden: true,
  },
]

const offlineRoute = [
  {
    path: "/offline",
    name: "Atender Offline",
    icon: <DashboardIcon />,
    component: PreFormOfflineScreen,
    hiddenHeader: true
  }
]

export const AdminRoutes = (isOnline) => {
  const userDetails = store.getState()?.app?.user

  if(VALE_USERS_EMAIL.includes(userDetails?.user?.email)) {
    return valeRoutes;
  }
  return getPlatform() === "1"
  ? dashboardRoutes
  : getPlatform() === "2"
  ? embrapaRoutes
  : getPlatform() === "3"
  ? chatRoutes
  : getPlatform() === "4"
  ? chatOnlyRoutes
  : isMobile ? [...offlineRoute, ...platformRoutes] : platformRoutes

}
  
const getAsyncDashRoutes = async (currentScope, scopeType) => {
  const scales = await Send.get(`/scale-project/${currentScope}`, `scopeType=${scopeType}`);

  if (scales && Array.isArray(scales)) {
    return scales.map((scale, idx) => ({
      path: `/esm/${scale?.id}`,
      name: `${scale?.title}` || `${idx + 1}`,
      component: ESMContainer,
      icon: <DashboardIcon />,
    }))
  }
  return []
}

export const AsyncRoutes = async (currentScope, scopeType) => {
  const platformType = getPlatform()
  if (platformType == 1 || platformType == 2) {
    return await getAsyncDashRoutes(currentScope, scopeType)
  }

  return []
}
